import { getAccessReviewSubordinate as apiGetAccessReviewSubordinate } from "api/accessReviewSubordinates";
import constate from "constate";
import { useLoadingState } from "hooks/useLoadingState";
import { Map } from "immutable";
import { type AccessReviewSubordinateModel } from "models/AccessReviewSubordinateModel";
import { useCallback, useState } from "react";

const useAccessReviewSubordinates = () => {
  const [accessReviewSubordinates, setAccessReviewSubordinates] = useState(Map<string, AccessReviewSubordinateModel>());
  const { isLoading: isGetLoading, withLoader: withGetLoader } = useLoadingState();

  const getAccessReviewSubordinate = useCallback(
    async (id: string): Promise<AccessReviewSubordinateModel | null> => {
      if (!id) return null;

      const accessReviewSubordinate = await withGetLoader(apiGetAccessReviewSubordinate(id));
      setAccessReviewSubordinates((current) => current.set(id, accessReviewSubordinate));
      return accessReviewSubordinate;
    },
    [withGetLoader],
  );

  const updateSubordinate = useCallback((id: string, subordinate: AccessReviewSubordinateModel) => {
    setAccessReviewSubordinates((current) => current.set(id, subordinate));
  }, []);

  return {
    actions: {
      getAccessReviewSubordinate,
      updateSubordinate,
    },
    state: { accessReviewSubordinates, isGetLoading },
  };
};

export const [AccessReviewSubordinatesProvider, useAccessReviewSubordinatesContext] =
  constate(useAccessReviewSubordinates);
